export const referenceRegex = /<Reference id="(\w+)"\s*\/>/g
